import { ENVIRONMENT_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { PageComponentCategoryCarouselComponent } from '../catalog/page/component/category-carousel/category-carousel.component';
import { PageComponentCustomformComponent } from '../catalog/page/component/customform/customform.component';
import { PageComponentEditorialLayoutComponent } from '../catalog/page/component/editorial-layout/editorial-layout.component';
import { PageComponentFaqComponent } from '../catalog/page/component/faq/faq.component';
import { PageComponentGuideComponent } from '../catalog/page/component/guide/guide.component';
import { PageComponentHeroBannerComponent } from '../catalog/page/component/hero-banner/hero-banner.component';
import { PageComponentIframeComponent } from '../catalog/page/component/iframe/iframe.component';
import { PageComponentImageQuoteComponent } from '../catalog/page/component/image-quote/image-quote.component';
import { PageComponentIndexedTextComponent } from '../catalog/page/component/indexed-text/indexed-text.component';
import { PageComponentJobVacancyTimerComponent } from '../catalog/page/component/job-vacancy-timer/job-vacancy-timer.component';
import { LargeCarouselComponent } from '../catalog/page/component/large-carousel/large-carousel.component';
import { PageComponentMobileRangeSquaresComponent } from '../catalog/page/component/mobile-range-squares/mobile-range-squares.component';
import { PlpCategoryQuicklinksLayoutComponent } from '../catalog/page/component/plp-category-quicklinks/plp-category-quicklinks-wrapper.component';
import { PlpCategoryQuicklinksBlockComponent } from '../catalog/page/component/plp-category-quicklinks/plp-category-quicklinks.component';
import { PLPHeadersComponent } from '../catalog/page/component/plp-headers/plp-headers.component';
import { PageComponentProductsCarouselComponent } from '../catalog/page/component/products-carousel/products-carousel.component';
import { QuickLinksComponent } from '../catalog/page/component/quick-links/quick-links.component';
import { PageComponentRangeSquaresComponent } from '../catalog/page/component/range-squares/range-squares.component';
import { PageComponentSocialMediaCarouselComponent } from '../catalog/page/component/social-media-carousel/social-media-carousel.component';
import { PageStoreFinderComponent } from '../catalog/page/component/store-finder/page-store-finder.component';
import { TrustMessagesComponent } from '../catalog/page/component/trust-messages/trust-messages.component';
import { PageComponentUpsellProductsCarouselComponent } from '../catalog/page/component/upsell-products-carousel/upsell-products-carousel.component';
import { PageComponentTextCarouselComponent } from '../catalog/page/component/text-carousel/text-carousel.component';
import { CmsProductDeliveryComponent } from '../catalog/product/cms/delivery/cms-product-delivery.component';
import { CmsProductReviewsComponent } from '../catalog/product/cms/product-reviews/cms-product-reviews.component';
import { CmsRelatedProductsComponent } from '../catalog/product/cms/related-products/cms-related-products.component';
import { ProductRangeBannerWrapperComponent } from '../catalog/product/range-banner/product-range-banner-wrapper.component';
import { ProductRangeBannerComponent } from '../catalog/product/range-banner/product-range-banner.component';
import { RelatedProductsComponent } from '../catalog/product/related-products/related-products.component';
import { UgcImageGalleryCmsProductViewComponent } from '../module/ugc-image/gallery/cms-product-view/ugc-image-gallery-cms-product-view.component';
import { UgcImageGalleryCmsComponent } from '../module/ugc-image/gallery/cms/ugc-image-gallery-cms.component';
import { UgcImageGalleryListingCmsComponent } from '../module/ugc-image/gallery/cms/ugc-image-gallery-listing-cms.component';
import { V12RetailFinanceInfoComponent } from '../module/v12-retail-finance/info/v12-retail-finance-info.component';
import { NewsletterCheckboxesComponent } from '../newsletter/newsletter-checkboxes.component';
import { SamplesCheckoutSuccessCmsComponent } from '../samples-checkout/success/samples-checkout-success-cms.component';
import { SearchLinksComponent } from '../search/ui/search-links.component';
import { SearchQuickLinksComponent } from '../search/ui/search-quick-links.component';
import { SearchTrendingComponent } from '../search/ui/search-trending.component';
import { CmsBlogComponentMoreStoriesComponent } from './blog/component/more-stories/cms-blog-component-more-stories.component';
import { CmsCarouselComponent } from './carousel/cms-carousel.component';
import { CmsHeroImageComponent } from './hero-image/cms-hero-image.component';
import { CmsHotspotsComponent } from './hotspots/cms-hotspots.component';
import { CmsHtmlComponent } from './html/cms-html.component';
import { CmsImageWithHotSpotsComponent } from './image-with-hot-spots/cms-image-with-hot-spots.component';
import { CmsImageComponent } from './image/cms-image.component';
import { CmsNewsletterComponent } from './newsletter/cms-newsletter.component';
import { CmsQuickLinksComponent } from './quick-links/cms-quick-links.component';
import { CmsRangeComponent } from './range/cms-range.component';
import { CmsComponentRowComponent } from './row/cms-component-row.component';
import { CmsSeoContentComponent } from './seo-content/cms-seo-content.component';
import { CmsTextComponent } from './text/cms-text.component';
import { CmsVideoComponent } from './video/cms-video.component';
const components = [
    CmsBlogComponentMoreStoriesComponent,
    CmsHtmlComponent,
    CmsImageComponent,
    CmsQuickLinksComponent,
    CmsTextComponent,
    CmsSeoContentComponent,
    CmsVideoComponent,
    RelatedProductsComponent,
    SearchTrendingComponent,
    SearchQuickLinksComponent,
    SearchLinksComponent,
    SamplesCheckoutSuccessCmsComponent,
    NewsletterCheckboxesComponent,
    V12RetailFinanceInfoComponent,
    UgcImageGalleryCmsProductViewComponent,
    UgcImageGalleryListingCmsComponent,
    UgcImageGalleryCmsComponent,
    CmsComponentRowComponent,
    CmsRangeComponent,
    CmsNewsletterComponent,
    CmsHeroImageComponent,
    CmsCarouselComponent,
    CmsBlogComponentMoreStoriesComponent,
    PageComponentCategoryCarouselComponent,
    PageComponentCustomformComponent,
    PageComponentEditorialLayoutComponent,
    PageComponentFaqComponent,
    PageComponentGuideComponent,
    PageComponentHeroBannerComponent,
    PageComponentIframeComponent,
    PageComponentImageQuoteComponent,
    PageComponentIndexedTextComponent,
    PageComponentJobVacancyTimerComponent,
    LargeCarouselComponent,
    PageComponentMobileRangeSquaresComponent,
    PlpCategoryQuicklinksLayoutComponent,
    PlpCategoryQuicklinksBlockComponent,
    PLPHeadersComponent,
    PageComponentProductsCarouselComponent,
    QuickLinksComponent,
    PageComponentRangeSquaresComponent,
    PageComponentSocialMediaCarouselComponent,
    PageStoreFinderComponent,
    TrustMessagesComponent,
    CmsProductDeliveryComponent,
    CmsProductReviewsComponent,
    CmsRelatedProductsComponent,
    ProductRangeBannerWrapperComponent,
    ProductRangeBannerComponent,
    CmsHotspotsComponent,
    CmsImageWithHotSpotsComponent,
    PageComponentUpsellProductsCarouselComponent,   PageComponentTextCarouselComponent
];
export const provideCmsComponents = () => {
    return makeEnvironmentProviders([
        {
            provide: ENVIRONMENT_INITIALIZER,
            useFactory: () => () => {
                return surviveTreeShaking(components);
            },
            multi: true
        }
    ]);
};